export default __webpack_public_path__ + "static/media/background.3407ccb8.jpg";